<template>
  <div>
    <form ref="loginForm">
      <img alt="" class="login-img" src="../assets/login-banner.png">
      <div class="login-input">
        <img src="../assets/username.png"/>
        <input type="text" v-model="loginForm.username" placeholder="请输入员工名称">
      </div>
      <div class="login-input">
        <img src="../assets/password.png"/>
        <input type="password" v-model="loginForm.password" placeholder="请输入密码">
      </div>
      <div>
        <button class="login-btn" @click="handleLogin" :disabled="btnDisable">登录</button>
      </div>
    </form>

    <base-dialog v-if="messageVisible" :title="title" width="80%" @close="close">
      <p>{{ message }}</p>
    </base-dialog>

    <div class="toast" v-show="toastShow">
      {{toastText}}
    </div>
  </div>
</template>

<script>
  import BaseDialog from "@/components/BaseDialog";
  import {WeChatUserInfo} from "@/api/Login";
  import {WX_CODE} from "@/config/app";
  export default {
      components: {BaseDialog},
      data() {
      return {
        loginForm: {
          username: '',
          password: ''
        },
          toastShow: false,
          toastText: '',

          title: '提示',
          messageVisible: false,
          message: "",

          btnDisable: false,
      };
    },

      created() {
          let adminToken = this.$cookies.get('ADMIN-TOKEN');
          if (adminToken === null || adminToken === '') {
              this.$cookies.set("openid", '');
          }
          let openId = this.$cookies.get("openid");
          if (openId === null || openId === '' || openId === 'undefined') {
              let local1 = window.location.href; // 获取页面url
              let local = local1.replace("sss", "#")
              let appid = WX_CODE;
              var agentid = '1000019'
              let code = this.GetUrlParame('code'); // 截取code
              // code = "666"
              // let code = local.match(/=(\S*)&state=STATE#/)
              if (code == null || code === '') { // 如果没有code，则去请求
                  this.$cookies.set("linkurl", local);
                  window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=12345ss&connect_redirect=1&agentid=${agentid}#wechat_redirect`
                  return
              } else {
                // WeChatUserInfo(code)//如果有code，说明用户点击了授权  将获取到的code传递给后台
                //       .then(res => {
                //     // 返回状态和UId
                //     if (res.data.openid) {
                //         // this.$cookies.set("openid", res.data.openid);
                //         localStorage.setItem("openid", res.data.openid);
                //     }
                // });
                return new Promise((resolve, reject) => {
                  WeChatUserInfo(code)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.$cookies.set("openid", response.data.openId);
                            // localStorage.setItem("openid", response.data.openid);
                            // this.$router.push({path: '/order'});
                            this.$store.commit("RECEIVE_ADMIN_NAME", response.data.username);
                            this.$store.commit("RECEIVE_ADMIN_TOKEN", response.data.token);
                            this.$store.commit("RECEIVE_LADY_ID", response.data.ladyId);
                            localStorage.setItem("RECEIVE_RULE_READ", 1);
                            localStorage.setItem("RECEIVE_PASS_WORD", 1);
                            // window.location.href = `${encodeURIComponent(local)}`
                            // this.$router.push({path: '/custom'});
                            // window.location.href = `http://5288u.com/#/custom`
                            // window.location.href = window.location.origin + window.location.pathname + window.location.hash
                            // const replaceUrl = 'http://' + window.location.host + '/#/callback/?code=' + code[1] + '&state=STATE'
                            // return location.replace(`${encodeURIComponent(local)}`)
                            resolve(response);
                            // return location.replace(`${encodeURIComponent(local)}`)

                            let linkurl = this.$cookies.get('linkurl');
                            // this.$router.push({path: '/order'});
                            window.location.href = linkurl
                        } else {
                            reject(response);
                            this.messageVisible = true;
                            this.message = response.message;
                            this.btnDisable = false;
                        }
                    })
                    .catch((error) => {
                      reject(error);
                    });
                });
              }
          } else {
              // localStorage.setItem('ADMIN-TOKEN', adminToken);
              this.$cookies.set("ADMIN-TOKEN", adminToken);
              // this.$router.push({path: '/order'});
              let localt = window.location.href; // 获取页面url
              if (localt.replace("sss", "#").indexOf("order") != -1) {
                this.$router.push({path: '/order'});
              } else if (localt.replace("sss", "#").indexOf("mine") != -1) {
                this.$router.push({path: '/mine'});
              } else {
                this.$router.push({path: '/order'});
              }
          }
      },
    methods: {
        // 截取code
        GetUrlParame (parameName) {
            /// 获取地址栏指定参数的值
            /// <param name="parameName">参数名</param>
            // 获取url中跟在问号后面的部分
            let parames = window.location.search;
            // 检测参数是否存在
            if (parames.indexOf(parameName) > -1) {
                let parameValue = '';
                parameValue = parames.substring(parames.indexOf(parameName), parames.length);
                // 检测后面是否还有参数
                if (parameValue.indexOf('&') > -1) {
                    // 去除后面多余的参数, 得到最终 parameName=parameValue 形式的值
                    parameValue = parameValue.substring(0, parameValue.indexOf('&'));
                    // 去掉参数名, 得到最终纯值字符串
                    parameValue = parameValue.replace(parameName + '=', '');
                    return parameValue;
                }
                return '';
            }
        },


        close() {
            this.messageVisible = false;
            this.$emit('close');
        },

        toast (e) {
            let _that = this;
            this.toastText = e;
            this.toastShow = true;
            setTimeout(function(){
                _that.toastShow = false
            }, 1500)
        },

        handleLogin() {
            if (this.loginForm.username === '') {
                this.toast('请输入账号');
                return
            }

            if (this.loginForm.password === '') {
                this.toast('请输入密码');
                return
            }
            this.btnDisable = true;
            this.$store.dispatch('Login', this.loginForm)
                .then((response) => {
                    if (response.code === this.$API_CODE.OK) {
                        this.$router.push({path: '/order'});
                    }
                    this.btnDisable = false;
                })
                .catch((err) => {
                    this.messageVisible = true;
                    this.message = err.message;
                    this.btnDisable = false;
                });
        },
    }
  }

</script>

<style lang="scss" scoped>

    .login-img {
      width: 100%;
      margin-bottom: 30px;
    }
    .login-input {
      margin: 10px auto;
      width: 80%;
      border: none;
      border-radius: 5px;
      border-bottom: 1px solid #BDBDBD;

      img {
        width: 20px;
        height: 20px;
        float: left;
        margin-top: 8px;
      }

      input {
        background: #f4f4f4;
        border: 0;
        font-size: 1rem;
        width: 85%;
        padding: 8px;
      }
    }
    .login-btn {
      width: 80%;
      padding: 10px;
      color: #ffffff;
      font-size: 1rem;
      border-radius: 5px;
      background: #2d8cf0;
      margin: 40px auto;
      border: 0;
    }

</style>
